<template>
  <sdui-scrollable-wrapper>
    <!-- HEADER -->
    <template #header>
      <sdui-general />
    </template>

    <!-- CONTENT -->
    <template #body>
      <RouterView />
    </template>

    <!-- FOOTER MENU AND NAV-->
    <template #footer>
      <sdui-nav-bar :fixed-to-bottom="false" />
    </template>

    <template #modals>
      <sdui-alert-modals />
    </template>
  </sdui-scrollable-wrapper>
</template>
<script>
import SduiGeneral from 'src/layout/SduiGeneral.vue'
import SduiAlertModals from 'src/layout/SduiAlertModals.vue'
import SduiNavBar from 'src/layout/SduiNavBar.vue'
import SduiScrollableWrapper from 'src/components/miscellaneous/ui/SduiScrollableWrapper.vue'
import Defer from 'src/mixins/miscellaneous/defer.js'

export default {
  name: 'SduiWithScrollContainer',
  components: {
    SduiGeneral,
    SduiAlertModals,
    SduiNavBar,
    SduiScrollableWrapper,
  },

  mixins: [Defer()],
}
</script>

<style scoped lang="scss">
#navbar-main {
  position: relative !important;
  z-index: 1030;
}

:deep(header > div) {
  top: 0 !important;
}

:deep(.navbar-main-container) {
  z-index: 1;
}

.reset-button {
  color: inherit !important;
}

:deep(.general-headroom) {
  position: relative !important;
}

:deep(.btn-notch) {
  z-index: 1;
}
</style>
